import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext.jsx';
import Logo from '../components/Logo.jsx';
import './SignIn.css';

/**
 * AuthCallback — destination for the magic-link redirect.
 *
 * Supabase processes the access/refresh tokens from the URL hash
 * automatically when the page loads (because we set
 * `detectSessionInUrl: true` in the client config). All this screen
 * has to do is wait for the auth state to settle and then route the
 * user onward — to Home if signed-in, to /signin if the link failed
 * or expired.
 */
export default function AuthCallback() {
  const navigate = useNavigate();
  const { user, loading } = useAuth();

  useEffect(() => {
    if (loading) return;
    navigate(user ? '/' : '/signin', { replace: true });
  }, [user, loading, navigate]);

  return (
    <div className="signin">
      <div className="signin-card">
        <Logo size={56} />
        <h1>Signing you in…</h1>
        <p>One moment.</p>
      </div>
    </div>
  );
}
